// AUTO-GENERATED by scripts/generate-build-info.js at build time.
// DO NOT EDIT and DO NOT COMMIT — this file is git-ignored.
export const BUILD_INFO = {
  version: '0.1.0',
  commit: 'b9f7336',
  branch: 'HEAD',
  buildTime: '2026-10-09T07:12:21.199Z',
} as const
